import React from "react";
import ReactDOM from "react-dom/client"; // Use client for React 19
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import Pusher from "pusher-js";
import "toastify-js/src/toastify.css";

export const pusher = new Pusher("77fe47d0e249770c7d32", {
  cluster: "eu",
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found. Ensure there is a div with id 'root' in your HTML.");
}

const root = ReactDOM.createRoot(rootElement); // No error since rootElement is guaranteed to exist
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorker.unregister();
